import { createApiClient } from '@agentic/api-client';
import { config } from './config.ts';

/** The workbench's typed API client (`/api` is proxied to the mock or the platform). */
export const client = createApiClient({ baseUrl: config.apiBase, credentials: 'include', retryMs: 1000 });
